// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"AgilityLoader_Wrapper__3kdQ2","ContentWrapper":"AgilityLoader_ContentWrapper__3axum","Svg":"AgilityLoader_Svg__mN1xi","Text":"AgilityLoader_Text__31HUf"};